export default function copyButton({ value, successText = 'Скопировано' }) {
    return {
        value,
        successText,
        copied: false,

        async copy() {
            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(this.value);
                } else {
                    // fallback для локалки
                    const input = document.createElement('input');
                    input.value = this.value;
                    document.body.appendChild(input);
                    input.select();
                    document.execCommand('copy');
                    document.body.removeChild(input);
                }

                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                }, 1500);

            } catch (e) {
                console.error('Copy failed:', e);
            }
        }
    };
}
